module.exports = __webpack_public_path__ + "static/2010-layer-2-2b6523b3b326e8ae27449056ee9ff987.png";